/* cdn.js — Club dei Nasi: premi per livello, navigazione interna, scelta di un premio, menu dell'account, spiegazioni. Nessuna dipendenza. */
(function () {
  'use strict';
  var fmt = function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var small = window.matchMedia('(max-width: 749px)');
  var noHover = window.matchMedia('(hover: none)');

  // ---------- premi e sconti: si parte da «Tutti», i filtri mostrano i premi che si aprono a un livello ----------
  document.querySelectorAll('[data-cdn-catalog]').forEach(function (cat) {
    var bar = cat.querySelector('[data-cdn-filter]'), grid = cat.querySelector('[data-cdn-rewards]'), cap = cat.querySelector('[data-cdn-caption]');
    if (!bar || !grid) return;
    var chips = Array.prototype.slice.call(bar.querySelectorAll('.cdn-chip'));
    // ricerca per nome e descrizione, insieme al filtro per livello; senza accenti e maiuscole
    var search = cat.querySelector('[data-cdn-rw-search]'), none = cat.querySelector('[data-cdn-rw-none]'), lvl = 'all', q = '';
    var norm = function (t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
    var apply = function () {
      var shown = 0;
      grid.querySelectorAll('.cdn-reward').forEach(function (card) {
        var ok = (lvl === 'all' || (lvl === 'ready' ? card.hasAttribute('data-ready') : card.getAttribute('data-level') === lvl)) && (!q || norm(card.textContent).indexOf(q) > -1);
        card.hidden = !ok; if (ok) shown++;
      });
      if (none) none.hidden = shown > 0;
    };
    if (search) search.addEventListener('input', function () { q = norm(search.value.trim()); apply(); });
    cat.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cdn-rw-clear]')) return;
      if (search) search.value = ''; q = ''; pick(chips[0]);
    });
    var pick = function (chip) {
      lvl = chip.getAttribute('data-level');
      chips.forEach(function (c) { var on = c === chip; c.setAttribute('aria-selected', on ? 'true' : 'false'); c.tabIndex = on ? 0 : -1; });
      apply();
      if (cap) cap.textContent = lvl === 'all' ? cap.getAttribute('data-all') : lvl === 'ready' ? 'I premi che puoi scegliere adesso con i tuoi punti.' : 'I premi che si aprono al ' + chip.getAttribute('data-name') + '.';
      if (bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: chip.offsetLeft - 20, behavior: 'smooth' });
    };
    chips.forEach(function (c) { c.tabIndex = c.getAttribute('aria-selected') === 'true' ? 0 : -1; });
    bar.addEventListener('click', function (e) { var c = e.target.closest('.cdn-chip'); if (c) pick(c); });
    bar.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = chips.indexOf(document.activeElement); if (i < 0) return;
      var n = chips[(i + (e.key === 'ArrowRight' ? 1 : chips.length - 1)) % chips.length];
      n.focus(); pick(n); e.preventDefault();
    });
    // «Scegli un premio» / «Vedili» (Il mio account): apre il filtro dei premi che si possono scegliere adesso
    document.addEventListener('click', function (e) {
      var go = e.target.closest('[data-cdn-rw-go]'); if (!go) return;
      var c = bar.querySelector('[data-level="' + go.getAttribute('data-cdn-rw-go') + '"]'); if (!c) return;
      e.preventDefault(); pick(c);
      var y = bar.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
    var fromHash = function () {
      var m = /^#premi-([a-z]+)$/.exec(location.hash);
      var c = m && bar.querySelector('[data-level="' + m[1] + '"]');
      if (c) { pick(c); cat.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    };
    fromHash();
    window.addEventListener('hashchange', fromHash);
  });

  // ---------- navigazione interna: evidenzia la sezione visibile ----------
  var jump = document.querySelector('[data-cdn-jump]');
  if (jump && 'IntersectionObserver' in window) {
    var links = Array.prototype.slice.call(jump.querySelectorAll('a'));
    var byId = {}; links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && byId[en.target.id]) {
          links.forEach(function (a) { a.classList.toggle('is-active', a === byId[en.target.id]); });
          var a = byId[en.target.id]; if (jump.scrollWidth > jump.clientWidth) jump.scrollTo({ left: a.offsetLeft - 24, behavior: 'smooth' });
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(byId).forEach(function (id) { var s = document.getElementById(id); if (s) io.observe(s); });
  }

  // ---------- riscatto di un premio: parla col motore del Club (/apps/naso/riscatta) ----------
  var dlg = document.querySelector('[data-cdn-dialog]');
  if (dlg) {
    var current = null;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cdn-redeem]'); if (!b) return;
      var avail = Number(dlg.querySelector('[data-cdn-d-confirm]').getAttribute('data-available')) || 0;
      current = { title: b.getAttribute('data-title'), points: Number(b.getAttribute('data-points')), kind: b.getAttribute('data-kind'), handle: b.getAttribute('data-handle'), bottone: b };
      dlg.querySelector('[data-cdn-d-title]').textContent = current.title;
      var isDiscount = current.kind === 'discount', note = dlg.querySelector('[data-cdn-d-note]'), kindEl = dlg.querySelector('[data-cdn-d-kind]');
      if (kindEl) kindEl.textContent = isDiscount ? 'Trasforma i punti in sconto' : 'Scegli un premio';
      if (note) note.textContent = note.getAttribute(isDiscount ? 'data-discount' : 'data-reward');
      dlg.querySelector('[data-cdn-d-points]').textContent = fmt(current.points) + ' punti';
      dlg.querySelector('[data-cdn-d-after]').textContent = fmt(Math.max(0, avail - current.points)) + ' punti';
      dlg.querySelector('[data-cdn-d-msg]').textContent = '';
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    });
    var avviso = function (testo, buono) {
      var grid = document.querySelector('[data-cdn-rewards]');
      var vecchio = document.querySelector('[data-cdn-esito]'); if (vecchio) vecchio.remove();
      var p = document.createElement('p');
      p.className = 'cdn-small'; p.setAttribute('data-cdn-esito', '');
      p.style.cssText = 'text-align:center;margin:16px 0 0;color:' + (buono ? 'var(--cdn-gold-ink)' : '#c96a68');
      p.textContent = testo;
      if (grid) grid.parentNode.insertBefore(p, grid);
      p.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    };
    dlg.addEventListener('close', function () {
      if (dlg.returnValue !== 'confirm' || !current) return;
      var proxy = window.mpNasoClub && window.mpNasoClub.proxy;
      var scelto = current;
      if (!proxy || !scelto.handle) {
        avviso('La scelta dei premi si accende a breve: "' + scelto.title + '" è stato annotato.', true);
        return;
      }
      if (scelto.bottone) { scelto.bottone.disabled = true; scelto.bottone.textContent = 'Un attimo…'; }
      fetch(proxy.replace(/\/$/, '') + '/riscatta', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ premio: scelto.handle })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (e) {
          if (e.ok && e.d.ok) {
            avviso('"' + scelto.title + '" è tuo: arriva nel pacco del prossimo ordine.' + (e.d.punti_usati ? ' Ti restano ' + fmt(e.d.punti_rimasti) + ' punti.' : ' Era compreso nel tuo livello.'), true);
            if (scelto.bottone) scelto.bottone.textContent = 'Riscattato';
            setTimeout(function () { location.reload(); }, 2500);
          } else {
            avviso(e.d && e.d.errore ? e.d.errore.charAt(0).toUpperCase() + e.d.errore.slice(1) + '.' : 'Non è andata: riprova fra poco.', false);
            if (scelto.bottone) { scelto.bottone.disabled = false; scelto.bottone.textContent = 'Scegli'; }
          }
        })
        .catch(function () {
          avviso('Non è andata: riprova fra poco.', false);
          if (scelto.bottone) { scelto.bottone.disabled = false; scelto.bottone.textContent = 'Scegli'; }
        });
    });
  }

  // ---------- stato del Club per questa pagina (scritto dall'header) ----------
  var club = window.cdnClub || { member: false, demo: false, favKey: 'guest', hub: '/pages/il-mio-account' };
  var loginUrl = function (path) { return '/customer_authentication/login?return_to=' + encodeURIComponent(path || club.hub); };

  // ---------- menu rapido dell'account (desktop, al passaggio del mouse: CSS) ----------
  document.querySelectorAll('[data-cdn-acc]').forEach(function (acc) {
    var btn = acc.querySelector('[data-cdn-acc-btn]'); if (!btn) return;
    acc.addEventListener('mouseenter', function () { btn.setAttribute('aria-expanded', 'true'); });
    acc.addEventListener('mouseleave', function () { btn.setAttribute('aria-expanded', 'false'); });
  });

  // ---------- pannello "Accedi o iscriviti" ----------
  // Chi non ha l'account: «Accedi» nell'header, cuore, inviti e carrello aprono il pannello del Club.
  // Accedi: l'email scritta qui arriva già compilata nella pagina sicura di Shopify (login_hint), dove si mette solo il codice.
  // Crea il tuo account: nome, cognome, compleanno e Bollettino restano in questo browser (cdn-signup) fino al ritorno,
  // poi la pagina account li usa per le domande di benvenuto. Il ritorno: account (predefinito), pagina corrente o carrello.
  var SIGNUP_KEY = 'cdn-signup';
  var auth = document.querySelector('[data-cdn-auth]');
  if (auth && auth.parentNode !== document.body) { document.body.appendChild(auth); auth.setAttribute('autofocus', ''); auth.tabIndex = -1; }
  var returnFor = function (ctx) { return (ctx === 'favorites' || ctx === 'here' || ctx === 'drop' ? location.pathname : ctx === 'cart' ? '/cart' : club.hub) + '?benvenuto=1'; };
  var setReturn = function (root, ret) {
    root.querySelectorAll('input[name="return_to"]').forEach(function (i) { i.value = ret; });
    root.querySelectorAll('[data-cdn-auth-go]').forEach(function (go) { go.href = loginUrl(ret) + '&locale=it' + (go.getAttribute('data-provider') ? '&acr_values=' + encodeURIComponent('provider:' + go.getAttribute('data-provider')) : ''); });
  };
  var showView = function (root, name) {
    root.querySelectorAll('[data-cdn-auth-view]').forEach(function (v) { v.hidden = v.getAttribute('data-cdn-auth-view') !== name; });
    var box = root.closest('dialog') || root;
    if (box.scrollTo) box.scrollTo({ top: 0 });
    var first = root.querySelector('[data-cdn-auth-view="' + name + '"] input:not([type="hidden"])');
    if (first && !noHover.matches) first.focus({ preventScroll: true });
  };
  var openAuth = function (ctx, view) {
    var ret = returnFor(ctx);
    if (!auth || typeof auth.showModal !== 'function') { location.href = loginUrl(ret); return; }
    var box = auth.querySelector('[data-cdn-auth-ctx]');
    var txt = ctx === 'favorites' ? auth.getAttribute('data-ctx-favorites') : ctx === 'cart' ? auth.getAttribute('data-ctx-cart') : ctx === 'drop' ? auth.getAttribute('data-ctx-drop') : '';
    if (box) { box.textContent = txt || ''; box.hidden = !txt; }
    setReturn(auth, ret);
    showView(auth, view || 'login');
    if (!auth.open) auth.showModal();
  };
  window.cdnOpenAuth = openAuth;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cdn-auth-open]');
    if (o && !club.member) {
      // nella pagina account il riquadro è già aperto: basta portarci lo sguardo
      var inline = !auth && document.querySelector('.cdn-authcard [data-cdn-auth-views]');
      if (inline) { e.preventDefault(); showView(inline, 'login'); inline.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      e.preventDefault(); e.stopPropagation(); openAuth(o.getAttribute('data-cdn-auth-open')); return;
    }
    var v = e.target.closest('[data-cdn-auth-view-open]');
    if (v) { var root = v.closest('[data-cdn-auth-views]'); if (root) { e.preventDefault(); showView(root, v.getAttribute('data-cdn-auth-view-open')); } return; }
    if (e.target.closest('[data-cdn-auth-close]') && auth) auth.close();
  }, true);
  if (auth) auth.addEventListener('click', function (e) { if (e.target === auth) auth.close(); });
  document.addEventListener('click', function (e) {
    var g = e.target.closest('[data-provider="google"]'); if (!g || g.getAttribute('data-ready') === 'true') return;
    e.preventDefault();
    var note = g.parentNode.querySelector('[data-cdn-google-pending]'); if (note) note.hidden = false;
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cdn-auth-form]'); if (!form) return;
    var email = (form.querySelector('input[name="login_hint"]') || {}).value || '';
    email = email.trim().toLowerCase();
    if (form.getAttribute('data-cdn-auth-form') === 'signup') {
      var data = { email: email, ts: Date.now() };
      form.querySelectorAll('[data-signup]').forEach(function (el) { data[el.getAttribute('data-signup')] = el.type === 'checkbox' ? el.checked : el.value.trim(); });
      try { localStorage.setItem(SIGNUP_KEY, JSON.stringify(data)); } catch (err) {}
    }
    // la pagina Shopify riceve solo il ritorno, la lingua e l'email: niente nome o compleanno nell'indirizzo
    e.preventDefault();
    var ret = (form.querySelector('input[name="return_to"]') || {}).value || club.hub + '?benvenuto=1';
    var going = form.querySelector('[data-cdn-auth-going]'); if (going) going.hidden = false;
    var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
    setTimeout(function () { location.href = loginUrl(ret) + '&locale=it&login_hint=' + encodeURIComponent(email); }, 450);
  }, true);
  if (location.hash === '#accedi' && !club.member) window.addEventListener('load', function () { openAuth(''); });
  if (location.hash === '#club-dei-nasi-menu') window.addEventListener('load', function () { document.querySelectorAll('[data-cdn-acc]').forEach(function (a) { var r = a.getBoundingClientRect(); if (r.width > 0 && getComputedStyle(a).visibility === 'visible') a.classList.add('is-open'); }); });

  // ---------- preferiti ----------
  // Una lista per cliente, in questo browser: [{h: handle, t: salvato il (ms), p: prezzo in centesimi quel giorno}].
  // Quando il backend del Club salverà la lista sull'account (app proxy → metafield del cliente) cambiano solo favLoad e favSave.
  var FAV_KEY = 'cdn-fav:' + club.favKey, FAV_MAX = 60;
  var favLoad = function () {
    var raw = [], seen = {};
    try { raw = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) {}
    if (!Array.isArray(raw)) return [];
    return raw.map(function (x) { return typeof x === 'string' ? { h: x, t: 0 } : x; }).filter(function (x) {
      if (!x || typeof x.h !== 'string' || !x.h || x.h.length > 255 || seen[x.h]) return false;
      seen[x.h] = true; return true;
    }).slice(0, FAV_MAX);
  };
  var favs = club.member ? favLoad() : [];
  var favSave = function () { try { localStorage.setItem(FAV_KEY, JSON.stringify(favs)); } catch (e) {} };
  var favAt = function (h) { for (var i = 0; i < favs.length; i++) { if (favs[i].h === h) return i; } return -1; };
  var paintFav = function () {
    document.querySelectorAll('[data-cdn-fav]').forEach(function (b) {
      var on = favAt(b.getAttribute('data-cdn-fav')) > -1, name = b.getAttribute('data-title');
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (name) b.setAttribute('aria-label', on ? 'Togli ' + name + ' dai preferiti' : 'Salva ' + name + ' nei preferiti');
      var t = b.querySelector('[data-cdn-fav-text]'); if (t) t.textContent = on ? 'Nei tuoi preferiti' : 'Salva nei preferiti';
    });
    document.querySelectorAll('[data-cdn-fav-count]').forEach(function (c) { c.textContent = favs.length; c.hidden = favs.length === 0; });
  };

  // messaggio dei preferiti: foto, testo e un'azione (Vedi, Annulla)
  var favToastEl = null, favToastTimer = 0;
  var favToast = function (o) {
    if (favToastEl) { favToastEl.remove(); clearTimeout(favToastTimer); }
    var t = document.createElement('div'); t.className = 'cdn-ftoast'; t.setAttribute('role', 'status');
    var hide = function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); if (favToastEl === t) favToastEl = null; }, 250); };
    if (o.img) { var im = document.createElement('img'); im.src = o.img; im.alt = ''; t.appendChild(im); }
    var s = document.createElement('span'); s.textContent = o.text; t.appendChild(s);
    if (o.action) {
      var a = document.createElement(o.href ? 'a' : 'button'); a.className = 'cdn-ftoast__a'; a.textContent = o.action;
      if (o.href) { a.href = o.href; } else { a.type = 'button'; a.addEventListener('click', function () { o.onAction(); hide(); }); }
      t.appendChild(a);
    }
    document.body.appendChild(t); favToastEl = t;
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    favToastTimer = setTimeout(hide, 5000);
  };

  // «I miei preferiti» (Il mio account): ogni scheda arriva dal negozio (/products/<handle>?view=cdn-fav), quindi prezzo,
  // formati, disponibilità e segni del Club sono quelli del momento. Le schede già scaricate restano in memoria.
  var favList = document.querySelector('[data-cdn-fav-list]');
  var favHtml = {}, favWait = {};
  var favFetch = function (h) {
    if (!favWait[h]) {
      favWait[h] = fetch('/products/' + encodeURIComponent(h) + '?view=cdn-fav', { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 404) return null;
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (html) {
        if (html === null) return null;
        var tpl = document.createElement('template'); tpl.innerHTML = html;
        var el = tpl.content.querySelector('[data-cdn-fcard]');
        if (!el) throw new Error('scheda mancante');
        favHtml[h] = el.outerHTML;
        return favHtml[h];
      }).finally(function () { delete favWait[h]; });
    }
    return favWait[h];
  };
  var favCard = function (fav, html) {
    var tpl = document.createElement('template'); tpl.innerHTML = html;
    var card = tpl.content.firstElementChild;
    var saved = card.querySelector('[data-cdn-fcard-saved]');
    if (saved && fav.t) { saved.textContent = 'Salvato il ' + new Date(fav.t).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' }); saved.hidden = false; }
    var now = Number(card.getAttribute('data-price')), drop = card.querySelector('[data-cdn-fcard-drop]');
    if (drop && fav.p && now && now < fav.p) drop.hidden = false;
    return card;
  };
  var renderFavList = function () {
    if (!favList) return;
    var box = favList.closest('[data-cdn-favs]') || favList.parentNode;
    var empty = box.querySelector('[data-cdn-fav-empty]'), note = box.querySelector('[data-cdn-fav-note]'), n = box.querySelector('[data-cdn-fav-n]');
    if (n) { n.textContent = favs.length; n.hidden = !favs.length; }
    if (note) note.hidden = !favs.length;
    if (empty) empty.hidden = favs.length > 0;
    var frag = document.createDocumentFragment(), queue = [];
    favs.forEach(function (fav) {
      if (favHtml[fav.h]) { frag.appendChild(favCard(fav, favHtml[fav.h])); return; }
      var ph = document.createElement('div'); ph.className = 'cdn-fcard cdn-fcard--wait'; ph.setAttribute('aria-hidden', 'true');
      ph.innerHTML = '<div class="cdn-fcard__media"></div><div class="cdn-fcard__body"><i></i><i></i></div>';
      frag.appendChild(ph); queue.push({ fav: fav, ph: ph });
    });
    favList.replaceChildren(frag);
    // al massimo 4 richieste insieme
    var next = function () {
      var job = queue.shift(); if (!job) return;
      favFetch(job.fav.h).then(function (html) {
        if (html === null) {
          var i = favAt(job.fav.h); if (i > -1) { favs.splice(i, 1); favSave(); paintFav(); }
          job.ph.remove();
          if (n) { n.textContent = favs.length; n.hidden = !favs.length; }
          if (empty) empty.hidden = favs.length > 0;
          if (note) note.hidden = !favs.length;
        } else if (job.ph.parentNode) {
          job.ph.replaceWith(favCard(job.fav, html));
        }
      }).catch(function () { job.ph.remove(); }).then(next);
    };
    for (var k = 0; k < 4; k++) next();
  };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cdn-fav]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (!club.member) { openAuth('favorites'); return; }
    var h = b.getAttribute('data-cdn-fav'), i = favAt(h), img = b.getAttribute('data-img') || '';
    if (i > -1) {
      var removed = favs.splice(i, 1)[0]; favSave(); paintFav();
      var card = favList && favList.contains(b) ? b.closest('[data-cdn-fcard]') : null;
      if (card) { card.classList.add('is-leaving'); setTimeout(renderFavList, 220); }
      favToast({ img: img, text: 'Tolto dai preferiti', action: 'Annulla', onAction: function () {
        if (favAt(removed.h) > -1) return;
        favs.splice(Math.min(i, favs.length), 0, removed); favSave(); paintFav(); renderFavList();
      } });
    } else {
      favs.unshift({ h: h, t: Date.now(), p: Number(b.getAttribute('data-price')) || 0 });
      if (favs.length > FAV_MAX) favs.length = FAV_MAX;
      favSave(); paintFav(); renderFavList();
      b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      favToast(favList ? { img: img, text: 'Salvato nei preferiti' } : { img: img, text: 'Salvato nei preferiti', action: 'Vedi', href: club.hub + '#preferiti' });
    }
  }, true);

  // altre schede del browser aperte sul sito: stessa lista
  window.addEventListener('storage', function (e) { if (e.key !== FAV_KEY || !club.member) return; favs = favLoad(); paintFav(); renderFavList(); });
  // card aggiunte dopo il caricamento (filtri della collezione, ricerca): il cuore mostra subito se è salvato
  if (club.member && 'MutationObserver' in window) {
    var favPaintSoon = 0;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var node = list[i].addedNodes[j];
          if (node.nodeType === 1 && (node.matches('[data-cdn-fav]') || node.querySelector('[data-cdn-fav]'))) {
            cancelAnimationFrame(favPaintSoon); favPaintSoon = requestAnimationFrame(paintFav); return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // scheda del preferito: il formato scelto aggiorna il prezzo; Aggiungi al carrello usa il carrello laterale del tema
  document.addEventListener('change', function (e) {
    var r = e.target; if (!r.matches || !r.matches('.cdn-fcard__sizes input[type="radio"]')) return;
    var price = r.closest('[data-cdn-fcard]').querySelector('[data-cdn-fcard-price]');
    if (price && r.getAttribute('data-price')) price.textContent = r.getAttribute('data-price');
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-cdn-fcard-form]'); if (!f) return;
    var btn = f.querySelector('[data-add-to-cart]');
    // senza carrello laterale il modulo parte normalmente e Shopify apre la pagina del carrello
    if (!btn || !document.querySelector('cart-drawer') || !(window.theme && theme.settings && theme.settings.cartType === 'drawer')) return;
    e.preventDefault();
    if (btn.disabled) return;
    var err = f.querySelector('[data-cart-errors-container]'); if (err) err.innerHTML = '';
    document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: btn }, bubbles: true }));
  });
  document.addEventListener('theme:product:add', function (e) {
    var btn = e.detail && e.detail.button; if (!btn || !btn.closest || !btn.closest('[data-cdn-fcard-form]')) return;
    btn.textContent = 'Aggiunto';
    setTimeout(function () { btn.textContent = 'Aggiungi al carrello'; btn.disabled = false; btn.classList.remove('is-added', 'is-loading'); }, 1800);
  });
  paintFav(); renderFavList();

  // ---------- scritte sulle foto delle card (stile «Sigillo», su tutto il sito) ----------
  // Legge la foto sotto ogni scritta con data-cdn-tone (e sotto Uomo/Donna/Unisex nelle varianti 12–13) e sceglie testo nero o bianco
  // con il contrasto migliore (WCAG). Fa lo stesso con la seconda foto che il tema mostra al passaggio del mouse (classi is-h…).
  // Le foto stanno sul dominio del negozio (/cdn/shop/files): il canvas si può leggere. Se non si può, resta il testo scuro.
  (function () {
    // card con segni del Club: home, collezioni, ricerca, correlati, preferiti (e le pagine di prova); dal 21-09 anche le foto della scheda
    var CARD = '.product-item__image, .cdn-rel__media, .cdn-pdp-slide';
    // il bollino Uomo/Donna/Unisex è scritto sulla foto su tutte le card, quindi ogni card con bollino o con segni del Club va trattata
    var SEGNI = '[data-cdn-tone], .cdn-pmarks--sigillo, .gender-badge';
    var daTrattare = function (c) { return !!c.querySelector(SEGNI) || !!c.closest('.cdn-variant'); };
    if (!document.querySelector(SEGNI)) return;
    var cv = document.createElement('canvas'); cv.width = 10; cv.height = 10;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    var lin = function (c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    var measure = function (img, area, r) {
      if (!img || !img.complete || !img.naturalWidth) return null;
      var nw = img.naturalWidth, nh = img.naturalHeight, s = Math.max(area.width / nw, area.height / nh);
      var ox = (area.width - nw * s) / 2, oy = (area.height - nh * s) / 2, pad = 5;
      var x0 = Math.max(0, (r.left - area.left - pad - ox) / s), y0 = Math.max(0, (r.top - area.top - pad - oy) / s);
      var w = Math.min(nw - x0, (r.width + pad * 2) / s), h = Math.min(nh - y0, (r.height + pad * 2) / s);
      if (w < 1 || h < 1) return null;
      try {
        cx.fillStyle = '#fff'; cx.fillRect(0, 0, 10, 10);
        cx.drawImage(img, x0, y0, w, h, 0, 0, 10, 10);
        var d = cx.getImageData(0, 0, 10, 10).data, n = d.length / 4, sum = 0, sq = 0;
        for (var i = 0; i < d.length; i += 4) {
          var L = 0.2126 * lin(d[i]) + 0.7152 * lin(d[i + 1]) + 0.0722 * lin(d[i + 2]);
          sum += L; sq += L * L;
        }
        var mean = sum / n, sd = Math.sqrt(Math.max(0, sq / n - mean * mean));
        return { dark: 1.05 / (mean + 0.05) > (mean + 0.05) / 0.05, busy: sd > 0.18 };
      } catch (e) { return null; }
    };
    var toneCard = function (card) {
      var area = card.getBoundingClientRect(); if (!area.width) return;
      var main = card.querySelector('.product-item__bg img') || card.querySelector('img');
      var hover = card.querySelector('hover-images [data-hover-slide] img');
      var els = card.querySelectorAll('[data-cdn-tone]');
      if (card.querySelector('.gender-badge') || card.closest('.cdn-variant--r12, .cdn-variant--r13, .cdn-variant--n1, .cdn-variant--n2, .cdn-variant--n3, .cdn-variant--n4, .cdn-variant--n5, .cdn-variant--n6')) els = card.querySelectorAll('[data-cdn-tone], .gender-badge');
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (!r.width) return;
        var t = measure(main, area, r);
        if (!t) return;
        var h = hover ? measure(hover, area, r) : null; if (!h) h = t;
        el.classList.toggle('is-dark', t.dark); el.classList.toggle('is-light', !t.dark);
        el.classList.toggle('is-hdark', h.dark); el.classList.toggle('is-hlight', !h.dark);
        el.classList.toggle('is-busy', t.busy);
        el.classList.add('is-toned');
      });
    };
    var all = function () { document.querySelectorAll(CARD).forEach(function (c) { if (daTrattare(c)) toneCard(c); }); };
    all();
    document.addEventListener('load', function (e) {
      var t = e.target; if (!t || t.tagName !== 'IMG' || !t.closest) return;
      var card = t.closest(CARD); if (card && daTrattare(card)) toneCard(card);
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-tab], [data-cdn-fav-tab]')) setTimeout(all, 80);
      // scheda prodotto: cambiando foto (miniature o frecce) la nuova foto diventa visibile solo dopo la dissolvenza
      if (e.target.closest('[data-thumb-link], .product__thumb, .product__slides .slider__button')) { setTimeout(all, 120); setTimeout(all, 450); }
    });
    var rt = 0; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(all, 200); });
    window.addEventListener('load', all);
  })();

  // ---------- il mio account: voce del menu attiva mentre si scorre ----------
  var acctNav = document.querySelector('[data-cdn-acct-nav]');
  if (acctNav && 'IntersectionObserver' in window) {
    var navLinks = Array.prototype.slice.call(acctNav.querySelectorAll('a[href^="#"]'));
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        navLinks.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
        var act = acctNav.querySelector('.is-active'); if (act && acctNav.scrollWidth > acctNav.clientWidth) acctNav.scrollTo({ left: act.offsetLeft - 20, behavior: 'smooth' });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    navLinks.forEach(function (a) { var s = document.getElementById(a.getAttribute('href').slice(1)); if (s) io2.observe(s); });
  }

  // ---------- spiegazioni: al passaggio del mouse (CSS) e con un tocco sui dispositivi senza mouse ----------
  document.addEventListener('click', function (e) {
    var tip = e.target.closest('[data-cdn-tip]');
    document.querySelectorAll('[data-cdn-tip].is-open').forEach(function (t) { if (t !== tip) t.classList.remove('is-open'); });
    if (!tip || tip.closest('a')) return;              // nelle card prodotto il tocco porta alla scheda, che spiega tutto
    tip.classList.toggle('is-open');
  });
  if (location.hash === '#club-dei-nasi-tip') {
    window.addEventListener('load', function () { var t = document.querySelector('.cdn-badge-tip') || document.querySelector('[data-cdn-tip]'); if (t) t.classList.add('is-open'); });
  }

  try { localStorage.removeItem('cdn-header'); localStorage.removeItem('cdn-header-switch'); } catch (e) {}

  // ---------- i miei ordini: dettagli nel sito ----------
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cdn-order-toggle]'); if (!t) return;
    var body = t.parentNode.querySelector('.cdn-order2__body'); if (!body) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true'); body.hidden = open;
  });

  // ---------- messaggio breve in basso ----------
  var toast = function (text) {
    var t = document.createElement('div'); t.className = 'cdn-toast'; t.setAttribute('role', 'status'); t.textContent = text;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () { t.classList.remove('is-on'); setTimeout(function () { t.remove(); }, 300); }, 2600);
  };

  // ---------- ritorno dall'iscrizione ----------
  var params = new URLSearchParams(location.search);
  var fromSignup = params.has('benvenuto');
  if (fromSignup && window.history && history.replaceState) {
    params.delete('benvenuto');
    var q = params.toString();
    history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
  }

  // ---------- il mio account: domande dopo l'iscrizione e dati del profilo ----------
  // Come Sephora, ma dopo la pagina sicura di Shopify: benvenuto da Naso Bianco, nome e compleanno, profilo olfattivo.
  // Salvataggio: con il proxy del Club (/apps/naso) i dati vanno sull'account; finché non c'è, restano in questo browser.
  var acct = document.querySelector('[data-cdn-acct]');
  var onb = document.querySelector('[data-cdn-onb]');
  if (acct) {
    var pKey = 'cdn-profile:' + acct.getAttribute('data-key');
    var doneKey = 'cdn-onb:' + acct.getAttribute('data-key');
    var store = {
      get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    };
    var profile = (function () { try { return JSON.parse(store.get(pKey) || '{}') || {}; } catch (e) { return {}; } })();
    // iscrizione fatta dal pannello del Club: nome, cognome, compleanno e Bollettino aspettano qui il ritorno dal codice
    var fromForm = false;
    try {
      var su = JSON.parse(localStorage.getItem('cdn-signup') || 'null');
      var myEmail = acct.getAttribute('data-email');
      if (su && (!myEmail || su.email === myEmail) && Date.now() - (su.ts || 0) < 7 * 864e5) {
        ['first_name', 'last_name', 'birthday', 'newsletter'].forEach(function (k) { if (su[k] !== undefined && su[k] !== '') profile[k] = su[k]; });
        store.set(pKey, JSON.stringify(profile));
        localStorage.removeItem('cdn-signup');
        fromForm = true;
      }
    } catch (e) {}
    var saveProfile = function (part) {
      Object.keys(part).forEach(function (k) { profile[k] = part[k]; });
      profile.updated_at = new Date().toISOString();
      store.set(pKey, JSON.stringify(profile));
      var proxy = window.mpNasoClub && window.mpNasoClub.proxy;
      if (proxy) {
        fetch(proxy.replace(/\/$/, '') + '/profile', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(part) }).catch(function () {});
      }
    };
    var setData = function (k, v) { document.querySelectorAll('[data-cdn-data="' + k + '"]').forEach(function (el) { el.textContent = v; }); };
    var birthdayText = function (d) {
      var dt = new Date(d + 'T12:00:00');
      return isNaN(dt) ? d : dt.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
    };
    var renderProfile = function () {
      if (profile.first_name) {
        setData('name', [profile.first_name, profile.last_name].filter(Boolean).join(' '));
        document.querySelectorAll('[data-cdn-profile-name]').forEach(function (el) { el.textContent = profile.first_name; });
        document.querySelectorAll('[data-cdn-hello]').forEach(function (el) { el.textContent = 'Ciao, ' + profile.first_name; });
        var hello = acct.querySelector('.cdn-acct__hello');
        var first = hello && hello.querySelector('[data-cdn-profile-first]');
        if (first) first.textContent = profile.first_name;
        else if (hello) { hello.textContent = 'Ciao, '; var sp = document.createElement('span'); sp.setAttribute('data-cdn-profile-first', ''); sp.textContent = profile.first_name; hello.appendChild(sp); }
      }
      setData('birthday', profile.birthday ? birthdayText(profile.birthday) : 'Da aggiungere');
      setData('phone', profile.phone || 'Da aggiungere');
      setData('newsletter', profile.newsletter === true ? 'Iscritto' : profile.newsletter === false ? 'Non iscritto' : '—');
      var likes = profile.likes || [];
      setData('profile', profile.profile_done ? (likes.length ? 'Ami ' + likes.slice(0, 3).join(', ').toLowerCase() + (likes.length > 3 ? '…' : '') : 'Completato') : 'Da completare');
      var nudge = acct.querySelector('[data-cdn-profile-nudge]');
      if (nudge) nudge.hidden = !!(profile.birthday && profile.profile_done);
    };
    renderProfile();

    var meForm = acct.querySelector('[data-cdn-me-form]');
    if (meForm) {
      ['first_name', 'last_name', 'birthday', 'phone'].forEach(function (k) { var el = meForm.elements[k]; if (el && profile[k]) el.value = profile[k]; });
      if (meForm.elements.newsletter && typeof profile.newsletter === 'boolean') meForm.elements.newsletter.checked = profile.newsletter;
      meForm.addEventListener('submit', function (e) {
        e.preventDefault();
        saveProfile({ first_name: meForm.elements.first_name.value.trim(), last_name: meForm.elements.last_name.value.trim(), birthday: meForm.elements.birthday.value, phone: meForm.elements.phone.value.trim(), newsletter: meForm.elements.newsletter.checked });
        renderProfile();
        var ok = meForm.querySelector('[data-cdn-me-saved]'); if (ok) { ok.hidden = false; setTimeout(function () { ok.hidden = true; }, 2600); }
      });
    }

    if (onb) {
      if (onb.parentNode !== document.body) document.body.appendChild(onb);
      var panes = Array.prototype.slice.call(onb.querySelectorAll('[data-pane]'));
      var steps = 3, mode = 'flow';
      var fillForms = function () {
        onb.querySelectorAll('[data-cdn-onb-form] input').forEach(function (inp) {
          var v = profile[inp.name];
          if (v === undefined) return;
          if (inp.type === 'checkbox' && Array.isArray(v)) inp.checked = v.indexOf(inp.value) > -1;
          else if (inp.type === 'checkbox') inp.checked = !!v;
          else if (inp.type === 'radio') inp.checked = inp.value === v;
          else inp.value = v;
        });
        onb.querySelectorAll('[data-flow]').forEach(function (b) { b.textContent = b.getAttribute(mode === 'edit' ? 'data-edit' : 'data-flow'); });
        var skip = onb.querySelector('[data-cdn-onb-skip]'); if (skip) skip.hidden = mode === 'edit';
      };
      var show = function (n) {
        panes.forEach(function (p) { p.hidden = Number(p.getAttribute('data-pane')) !== n; });
        var label = onb.querySelector('[data-cdn-onb-label]'), bar = onb.querySelector('[data-cdn-onb-bar]');
        var done = n > steps;
        if (label) label.textContent = done ? 'Fatto' : mode === 'edit' ? (n === 3 ? 'Profilo olfattivo' : 'I tuoi dati') : (onb.getAttribute('data-label') || '').replace('[n]', n).replace('[tot]', steps);
        if (bar) bar.style.width = (mode === 'edit' ? 100 : Math.round(Math.min(n, steps) / steps * 100)) + '%';
        onb.scrollTop = 0;
        var pane = panes[n - 1];
        var typing = n === 2 && !noHover.matches;
        var focus = pane && (typing ? pane.querySelector('input') : pane.querySelector('h2'));
        if (focus) { if (!typing) focus.tabIndex = -1; focus.focus({ preventScroll: true }); }
      };
      var openOnb = function (n, m) {
        if (typeof onb.showModal !== 'function') return;
        mode = m || 'flow';
        fillForms(); show(n || 1);
        if (!onb.open) onb.showModal();
      };
      var closeOnb = function () { if (onb.open) onb.close(); };
      onb.addEventListener('close', function () { if (mode === 'flow') store.set(doneKey, '1'); });
      document.addEventListener('click', function (e) {
        var o = e.target.closest('[data-cdn-onb-open]');
        if (o) { e.preventDefault(); openOnb(Number(o.getAttribute('data-cdn-onb-open')) || 1, o.getAttribute('data-mode') || 'flow'); return; }
        if (!onb.contains(e.target)) return;
        if (e.target.closest('[data-cdn-onb-next]')) { show(profile.first_name ? 3 : 2); return; }
        if (e.target.closest('[data-cdn-onb-skip]')) { show(4); return; }
        if (e.target.closest('[data-cdn-onb-close]')) closeOnb();
      });
      var values = function (form) {
        var out = {};
        Array.prototype.forEach.call(form.elements, function (el) {
          if (!el.name) return;
          if (el.type === 'checkbox' && (el.name === 'likes' || el.name === 'dislikes')) { out[el.name] = out[el.name] || []; if (el.checked) out[el.name].push(el.value); }
          else if (el.type === 'checkbox') out[el.name] = el.checked;
          else if (el.type === 'radio') { if (el.checked) out[el.name] = el.value; }
          else out[el.name] = el.value.trim();
        });
        return out;
      };
      onb.querySelectorAll('[data-cdn-onb-form]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var kind = form.getAttribute('data-cdn-onb-form');
          var data = values(form);
          if (kind === 'profile') data.profile_done = true;
          saveProfile(data); renderProfile();
          if (mode === 'edit') { closeOnb(); toast(onb.getAttribute('data-saved') || 'Salvato'); return; }
          show(kind === 'data' ? 3 : 4);
        });
      });
      // si apre da sola: dopo l'iscrizione dal pannello, a chi si è iscritto da poco o non ci ha ancora detto come si chiama
      // (una volta per browser); nella demo basta ?benvenuto=1
      var isNew = acct.getAttribute('data-new') === 'true';
      var noName = acct.getAttribute('data-noname') === 'true' && !profile.first_name;
      if ((fromSignup && club.demo) || fromForm || ((isNew || noName) && !store.get(doneKey))) openOnb(1, 'flow');
    }
  } else if (fromSignup && club.member && (club.isNew || club.demo) && club.welcome) {
    // iscrizione partita da un profumo, dai preferiti o dal carrello: si resta qui, con un benvenuto breve
    var w = document.createElement('div');
    w.className = 'cdn-welcome'; w.setAttribute('role', 'status');
    w.innerHTML = '<img alt="" width="52" height="52"><div><b></b><p></p><a></a></div><button type="button" aria-label="Chiudi">&times;</button>';
    w.querySelector('img').src = club.seal;
    w.querySelector('b').textContent = club.welcome.kicker;
    w.querySelector('p').textContent = club.welcome.text;
    var a = w.querySelector('a'); a.textContent = club.welcome.cta; a.href = club.hub;
    w.querySelector('button').addEventListener('click', function () { w.remove(); });
    document.body.appendChild(w);
  }
  // ---------- drop (5.3): conto alla rovescia, Avvisami, I miei drop, nuovo livello ----------
  var pad2 = function (n) { return (n < 10 ? '0' : '') + n; };
  var counters = Array.prototype.slice.call(document.querySelectorAll('[data-cdn-countdown]'));
  if (counters.length) {
    var tick = function () {
      var now = Date.now() / 1000;
      counters.forEach(function (el) {
        var left = Number(el.getAttribute('data-cdn-countdown')) - now;
        if (!(left > 0)) {
          if (el.hasAttribute('data-cdn-finished')) return;
          el.setAttribute('data-cdn-finished', '');
          if (el.getAttribute('data-cdn-done')) el.textContent = el.getAttribute('data-cdn-done');
          if (el.hasAttribute('data-cdn-unlock')) { document.documentElement.classList.remove('mp-nc-locked'); document.body.classList.remove('mp-nc-locked'); }
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = Math.floor(left % 60);
        el.textContent = el.hasAttribute('data-cdn-short')
          ? (d > 0 ? d + 'g ' + h + 'h' : h + 'h ' + pad2(m) + 'm')
          : (d > 0 ? pad2(d) + 'g ' + pad2(h) + 'h ' + pad2(m) + 'm' : pad2(h) + ':' + pad2(m) + ':' + pad2(s));
      });
    };
    tick(); setInterval(tick, 1000);
  }
  // scheda prodotto, uscita in arrivo: giorni / ore / minuti / secondi in quattro caselle. A zero la scheda si ricarica e mostra
  // «Aggiungi al carrello» (solo se era aperta prima dell'ora, così una pagina rimasta in cache non ricarica all'infinito).
  Array.prototype.forEach.call(document.querySelectorAll('[data-cdn-cd]'), function (box) {
    var end = Number(box.getAttribute('data-cdn-cd')), launch = box.closest('[data-cdn-launch]'), timer = 0, first = true;
    var put = function (u, v) { var el = box.querySelector('[data-u="' + u + '"]'); if (el && el.textContent !== v) el.textContent = v; };
    var run = function () {
      var left = Math.max(0, Math.floor(end - Date.now() / 1000));
      var d = Math.floor(left / 86400);
      put('d', d > 99 ? String(d) : pad2(d)); put('h', pad2(Math.floor(left % 86400 / 3600))); put('m', pad2(Math.floor(left % 3600 / 60))); put('s', pad2(left % 60));
      if (left > 0) { first = false; return; }
      clearInterval(timer);
      // chi non ha il livello non può comprarlo nemmeno all'apertura: il conto sparisce, resta il banner del livello
      if (!box.hasAttribute('data-cdn-unlock')) { if (launch) launch.hidden = true; return; }
      if (launch) launch.classList.add('is-open');
      document.documentElement.classList.remove('mp-nc-locked'); document.body.classList.remove('mp-nc-locked');
      if (!first) setTimeout(function () { location.reload(); }, 1500);
    };
    run(); if (launch && !launch.hidden && !launch.classList.contains('is-open')) timer = setInterval(run, 1000);
  });

  var NOTIFY_KEY = 'cdn-notify:' + (club.favKey || 'guest');
  var readNotify = function () { try { return JSON.parse(localStorage.getItem(NOTIFY_KEY) || '[]'); } catch (e) { return []; } };
  var writeNotify = function (list) { try { localStorage.setItem(NOTIFY_KEY, JSON.stringify(list)); } catch (e) {} };
  var mine = document.querySelector('[data-cdn-drops="mine"]');
  if (mine && club.demo) { try { if (localStorage.getItem(NOTIFY_KEY) === null) writeNotify(Array.prototype.slice.call(mine.querySelectorAll('[data-cdn-drop]:not(.cdn-rel--open)'), 0, 2).map(function (c) { return c.getAttribute('data-cdn-drop'); })); } catch (e) {} }
  var paintNotify = function () {
    var list = readNotify();
    Array.prototype.forEach.call(document.querySelectorAll('[data-cdn-notify]'), function (b) {
      var on = list.indexOf(b.getAttribute('data-cdn-notify')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.classList.toggle('is-on', on);
      var off = b.querySelector('[data-cdn-notify-off]'), yes = b.querySelector('[data-cdn-notify-on]');
      if (off) off.hidden = on; if (yes) yes.hidden = !on;
    });
    if (mine) {
      var shown = 0;
      Array.prototype.forEach.call(mine.querySelectorAll('[data-cdn-drop]'), function (c) { var on = list.indexOf(c.getAttribute('data-cdn-drop')) > -1; c.hidden = !on; if (on) shown++; });
      var empty = mine.querySelector('[data-cdn-drops-empty]'); if (empty) empty.hidden = shown > 0;
    }
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cdn-notify]'); if (!b) return;
    var h = b.getAttribute('data-cdn-notify'), list = readNotify(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    writeNotify(list); paintNotify();
    var proxy = window.mpNasoClub && window.mpNasoClub.proxy;
    if (proxy) fetch(proxy + '/notify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handle: h, on: i < 0 }) }).catch(function () {});
  });
  paintNotify();

  var utabs = document.querySelector('[data-cdn-utabs]');
  if (utabs) {
    var uRows = Array.prototype.slice.call(document.querySelectorAll('[data-cdn-drops="page"] [data-cdn-drop]'));
    var uGroups = Array.prototype.slice.call(document.querySelectorAll('[data-cdn-drops="page"] [data-cdn-group]'));
    var uEmpty = document.querySelector('[data-cdn-tab-empty]');
    var setU = function (tab) {
      Array.prototype.forEach.call(utabs.querySelectorAll('[data-tab]'), function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === tab ? 'true' : 'false'); });
      var shown = 0;
      uRows.forEach(function (r) { var ok = tab === 'all' || r.getAttribute('data-cdn-drop-type') === tab; r.hidden = !ok; if (ok) shown++; });
      uGroups.forEach(function (g) { g.hidden = !g.querySelector('[data-cdn-drop]:not([hidden])'); });
      if (uEmpty) { uEmpty.hidden = shown > 0 || tab === 'all'; uEmpty.textContent = uEmpty.getAttribute('data-' + tab) || ''; }
    };
    utabs.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b) setU(b.getAttribute('data-tab')); });
  }

  var gate = document.querySelector('[data-cdn-gate-dialog]');
  if (gate && typeof gate.showModal === 'function') {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cdn-gate]'); if (!b) return;
      e.preventDefault();
      var img = gate.querySelector('[data-cdn-gate-img]'), src = b.getAttribute('data-img');
      if (img && src) img.src = src;
      var ret = encodeURIComponent(b.getAttribute('data-return') || location.pathname);
      Array.prototype.forEach.call(gate.querySelectorAll('[data-cdn-gate-login],[data-cdn-gate-signup]'), function (a) { a.href = '/customer_authentication/login?locale=it&return_to=' + ret; });
      gate.showModal();
    });
    gate.addEventListener('click', function (e) { if (e.target === gate || e.target.closest('[data-cdn-gate-close]')) gate.close(); });
  }

  // ---------- spiegazioni di Privé, Limited e livello del Club ----------
  // Computer: scheda al passaggio del mouse; ci si può entrare per cliccare il link; un clic la fissa. Telefono: foglio dal basso.
  // Contenuto da data-cdn-info (JSON: l = livello {k,kick,n,s,x,y,ok}, b = blocchi [{t,x,d,c}], u/ut/uk = invito) oppure dal formato vecchio
  // data-t/k/x/y/u/ut (etichette classiche). Tutto il testo entra con textContent.
  var infoHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ICO_LOCK = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>';
  var ICO_OK = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4L19 7"/></svg>';
  var ICO_ARROW = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var infoEl = null, infoSheet = null, infoFor = null, infoPinned = false, infoTimer = 0, infoWait = 0;
  var infoData = function (el) {
    var raw = el.getAttribute('data-cdn-info');
    if (raw) { try { return JSON.parse(raw); } catch (e) {} }
    var g = function (k) { return el.getAttribute('data-' + k) || ''; };
    return { b: [{ t: g('t'), x: g('x'), d: g('k') }], y: g('y'), u: g('u'), ut: g('ut') };
  };
  var infoFill = function (box, d) {
    box.textContent = '';
    var add = function (parent, tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null && text !== '') n.textContent = text; parent.appendChild(n); return n; };
    if (d.l && d.l.n) {
      // livello: ceralacca, occhiello («Riservato» / «Per te») e nome; la frase sta sotto, larga quanto la scheda
      var lv = add(box, 'div', 'cdn-info__lv' + (d.l.k ? ' cdn-info__lv--' + d.l.k : ''));
      if (d.l.s) { var im = add(lv, 'img', 'cdn-info__seal'); im.src = d.l.s; im.alt = ''; im.width = 46; im.height = 46; }
      var tx = add(lv, 'div', 'cdn-info__lvt');
      var kick = add(tx, 'p', 'cdn-info__kick');
      if (d.l.ok) kick.insertAdjacentHTML('afterbegin', ICO_OK);
      add(kick, 'span', null, d.l.kick || (d.l.ok ? 'Per te' : 'Riservato'));
      add(tx, 'p', 'cdn-info__nome', d.l.n);
      if (d.l.x) add(box, 'p', 'cdn-info__x cdn-info__x--lv', d.l.x);
      if (d.l.y) add(box, 'p', 'cdn-info__y', d.l.y);
    }
    (d.b || []).forEach(function (b) {
      if (!b || !b.t) return;
      var bl = add(box, 'div', 'cdn-info__b' + (b.c ? ' cdn-info__b--' + b.c : ''));
      add(bl, 'p', 'cdn-info__h', b.t);
      if (b.x) add(bl, 'p', 'cdn-info__x', b.x);
      if (b.d) add(bl, 'p', 'cdn-info__d', b.d);
    });
    if (d.y && !(d.l && d.l.n)) add(box, 'p', 'cdn-info__y', d.y);
    if (d.u) {
      var a = add(box, 'a', 'cdn-info__a'); a.href = d.u;
      var at = add(a, 'span', 'cdn-info__at');
      if (d.uk) add(at, 'span', 'cdn-info__ak', d.uk);
      add(at, 'span', 'cdn-info__al', d.ut || 'Scopri di più');
      a.insertAdjacentHTML('beforeend', ICO_ARROW);
    }
  };
  var infoHide = function () { clearTimeout(infoTimer); infoPinned = false; infoFor = null; if (infoEl) infoEl.classList.remove('is-on'); };
  var infoHideSoon = function () { if (infoPinned) return; clearTimeout(infoTimer); infoTimer = setTimeout(infoHide, 160); };
  var infoShow = function (el, pin) {
    clearTimeout(infoTimer);
    if (!infoEl) {
      infoEl = document.createElement('div'); infoEl.className = 'cdn-info'; infoEl.setAttribute('role', 'tooltip');
      document.body.appendChild(infoEl);
      infoEl.addEventListener('mouseenter', function () { clearTimeout(infoTimer); });
      infoEl.addEventListener('mouseleave', function (e) { if (!(infoFor && infoFor.contains(e.relatedTarget))) infoHideSoon(); });
    }
    if (infoFor !== el) { infoFill(infoEl, infoData(el)); infoFor = el; }
    if (pin) infoPinned = true;
    infoEl.classList.add('is-on');
    var r = el.getBoundingClientRect(), w = infoEl.offsetWidth, h = infoEl.offsetHeight, gap = 10, vw = document.documentElement.clientWidth || window.innerWidth;
    // allineata a sinistra con la scritta; se non c'è spazio (es. la (i) del banner a destra) allineata a destra con la scritta
    var left = r.left + w > vw - 12 ? r.right - w : r.left;
    left = Math.min(Math.max(12, left), vw - w - 12);
    var top = r.bottom + gap, below = true;
    if (top + h > window.innerHeight - 12) { top = Math.max(12, r.top - h - gap); below = false; }
    infoEl.style.left = left + 'px'; infoEl.style.top = top + 'px';
    infoEl.classList.toggle('is-above', !below);
  };
  var infoClose = function () { if (infoSheet && infoSheet.classList.contains('is-open')) { infoSheet.classList.remove('is-open'); document.documentElement.classList.remove('cdn-xlock'); } };
  var infoOpen = function (el) {
    infoHide();
    if (!infoSheet) {
      infoSheet = document.createElement('div'); infoSheet.className = 'cdn-infosheet';
      infoSheet.innerHTML = '<div class="cdn-infosheet__bg" data-info-close></div><div class="cdn-infosheet__box" role="dialog" aria-modal="true" aria-label="Spiegazione"><span class="cdn-infosheet__grip" aria-hidden="true"></span><button type="button" class="cdn-infosheet__x" data-info-close aria-label="Chiudi">&times;</button><div class="cdn-info cdn-info--sheet"></div></div>';
      document.body.appendChild(infoSheet);
      infoSheet.addEventListener('click', function (e) { if (e.target.closest('[data-info-close]')) infoClose(); });
    }
    infoFill(infoSheet.querySelector('.cdn-info'), infoData(el));
    infoSheet.classList.add('is-open'); document.documentElement.classList.add('cdn-xlock');
    var x = infoSheet.querySelector('.cdn-infosheet__x'); if (x) x.focus({ preventScroll: true });
  };
  var infoTrigger = function (t) { return t && t.closest ? t.closest('[data-cdn-explain]') : null; };
  document.addEventListener('click', function (e) {
    var el = infoTrigger(e.target);
    if (!el) { if (infoPinned && infoEl && !infoEl.contains(e.target)) infoHide(); return; }
    e.preventDefault(); e.stopPropagation(); clearTimeout(infoWait);
    if (infoHover.matches) { if (infoPinned && infoFor === el) infoHide(); else infoShow(el, true); } else infoOpen(el);
  }, true);
  // al passaggio: parte dopo un attimo (niente lampi mentre il mouse attraversa le card); se una scheda è già aperta cambia subito
  document.addEventListener('mouseover', function (e) {
    if (!infoHover.matches) return;
    var el = infoTrigger(e.target); if (!el || el.contains(e.relatedTarget)) return;
    clearTimeout(infoWait);
    if (infoPinned && infoFor !== el) infoPinned = false;
    if (infoEl && infoEl.classList.contains('is-on')) infoShow(el, false);
    else infoWait = setTimeout(function () { infoShow(el, false); }, 140);
  });
  document.addEventListener('mouseout', function (e) { var el = infoTrigger(e.target); if (el && !el.contains(e.relatedTarget)) { clearTimeout(infoWait); if (!(infoEl && infoEl.contains(e.relatedTarget))) infoHideSoon(); } });
  document.addEventListener('focusin', function (e) { var el = infoTrigger(e.target); var kb = true; try { kb = el && el.matches(':focus-visible'); } catch (x) {} if (el && kb) infoShow(el, false); });
  document.addEventListener('focusout', function (e) { if (infoTrigger(e.target) && !(infoEl && infoEl.contains(e.relatedTarget))) infoHideSoon(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { infoHide(); infoClose(); } });
  window.addEventListener('scroll', infoHide, { passive: true });

  var lvup = document.querySelector('[data-cdn-lvup]');
  if (lvup && typeof lvup.showModal === 'function') {
    var gIdx = Number(lvup.getAttribute('data-grade-i')) || 0, LV_KEY = 'cdn-level:' + (club.favKey || 'guest'), seen = null;
    try { seen = localStorage.getItem(LV_KEY); } catch (e) {}
    if (location.hash === '#salito' || (seen !== null && gIdx > Number(seen))) lvup.showModal();
    try { localStorage.setItem(LV_KEY, String(gIdx)); } catch (e) {}
    lvup.addEventListener('click', function (e) { if (e.target === lvup || e.target.closest('[data-cdn-lvup-close]')) lvup.close(); });
  }
})();
